import { Link } from "react-router-dom";
import { ArrowUpRight, Users, Maximize } from "lucide-react";
import { STUDIOS } from "../data/site";
import { Reveal, Overline } from "./Reveal";
import { useI18n } from "../i18n/LanguageContext";

export const StudioCards = () => {
  const { t } = useI18n();
  return (
    <section data-testid="studios-section" className="max-w-7xl mx-auto px-6 md:px-10 py-24 md:py-32">
      <Reveal>
        <Overline>{t("studios.overline")}</Overline>
        <h2 className="font-serif text-4xl md:text-6xl tracking-tighter text-pine mt-4 max-w-2xl leading-[1.05]">
          {t("studios.title1")}
          <span className="italic text-wood-dark">{t("studios.title2a")}</span>
        </h2>
      </Reveal>

      <div className="grid md:grid-cols-12 gap-8 md:gap-6 mt-16 md:mt-24">
        {STUDIOS.map((studio, i) => {
          const content = t(`studioData.${studio.slug}`);
          return (
            <Reveal
              key={studio.slug}
              delay={i * 0.15}
              className={`md:col-span-6 ${i === 1 ? "md:mt-32" : ""}`}
            >
              <Link
                to={`/studio/${studio.slug}`}
                data-testid={`studio-card-${studio.slug}`}
                className="group block"
              >
                <div className="relative overflow-hidden">
                  <img
                    src={studio.image}
                    alt={studio.name}
                    loading="lazy"
                    className="w-full aspect-[4/5] md:aspect-[3/4] object-cover transition-transform duration-700 ease-out group-hover:scale-105"
                  />
                  <span className="absolute top-6 left-6 font-serif text-6xl text-cream/80">{studio.numeral}</span>
                </div>
                <div className="relative bg-pine text-cream p-8 md:p-10 -mt-16 md:-mt-24 mx-6 md:mx-10 z-10 transition-transform duration-500 group-hover:-translate-y-2">
                  <h3 className="font-serif text-2xl md:text-3xl tracking-tight">{studio.name}</h3>
                  <p className="text-cream/60 text-sm mt-2 italic font-serif">{content.tagline}</p>
                  <div className="flex items-center gap-6 mt-6 text-xs uppercase tracking-[0.15em] text-wood-light">
                    <span className="flex items-center gap-2"><Users aria-hidden className="w-4 h-4" />{content.capacity}</span>
                    <span className="flex items-center gap-2"><Maximize aria-hidden className="w-4 h-4" />{studio.surface}</span>
                  </div>
                  <span className="mt-6 inline-flex items-center gap-2 text-sm font-semibold text-wood group-hover:gap-4 transition-all duration-300">
                    {t("studios.discover")} <ArrowUpRight aria-hidden className="w-4 h-4" />
                  </span>
                </div>
              </Link>
            </Reveal>
          );
        })}
      </div>
    </section>
  );
};
